/**
 * Build-time PRODUCT brand string.
 *
 * This app is deployed by metabus-apps `.github/workflows/deploy-operator.yml` to
 * metabus-apps-operator.web.app. It was lifted from the dialer repo's `frontend/`,
 * whose two old sites (buildgravity-dialer.web.app, metabus-dialer.web.app) have
 * been frozen since June 2026 and are no longer deployed.
 *
 * `VITE_APP_BRAND_NAME` is a PUBLIC build-time string (no secret).
 * deploy-operator.yml sets it to "Metabus" for the deployed operator app.
 * Unbranded local builds retain the legacy "BuildGravity" fallback.
 *
 * NOTE: this is the PRODUCT / app-shell brand only. The per-tenant active-tenant
 * name shown in the sidebar (Navigation.tsx) is a separate concept and is driven
 * by the authenticated user's tenant - do NOT route that through this const.
 */
export const BRAND_NAME: string =
  import.meta.env.VITE_APP_BRAND_NAME || 'BuildGravity'

/**
 * Build-time PRODUCT logo asset path (public, no secret), set like BRAND_NAME.
 * When unset it is "" (EMPTY) and the sidebar + login card render TEXT-ONLY
 * (no <img>). deploy-operator.yml does not set it today.
 */
export const BRAND_LOGO: string =
  import.meta.env.VITE_APP_BRAND_LOGO ?? ''

/**
 * Browser-tab / login-card PRODUCT title, e.g. "BuildGravity Sales Engine" /
 * "Metabus Sales Engine".
 *
 * The product is "Sales Engine" - this is the app-shell product name, NOT the
 * click-to-call "Dialer" calling tool (the phone-dialer nav item / panel keep
 * their "Dialer" label; only the PRODUCT name changed here).
 */
export const PRODUCT_TITLE = `${BRAND_NAME} Sales Engine`
